export const projectdata = [
  {
    id: 1,
    title: "MD. Akbar Hossan Portfolio",
    img: require("./project-Img/ResponsiveView.png"),
    view: 102,
    lan: ["JavaScripts", "Tailwind", "ReactJS"],
    link: "https://telepathist-samrat.netlify.app/",
  },
  {
    id: 2,
    title: "Topten Search",
    img: require("./project-Img/Topten.png"),
    view: 102,
    lan: ["Html", "CSS", "ReactJS", "Material UI"],
    link: "https://topten-search.netlify.app/",
  },
  {
    id: 3,
    title: "Agency Digital Site (Client)",
    img: require("./project-Img/laptop.png"),
    view: 102,
    lan: ["Html", "CSS", "ReactJS", "Material UI"],
    link: "http://agency-ds.netlify.app/",
  },
  {
    id: 4,
    title: "Saffran Restaurant Logo",
    img: require("./project-Img/RestaurantsLogo.png"),
    view: 102,
    lan: ["Adobe", "Illustrator", "Logo"],
    link: "https://www.behance.net/gallery/205306603/Restaurant-Logo",
    btn: "Preview",
  },
  {
    id: 5,
    title: "Creative Business Agency",
    img: require("./project-Img/socialMedia.jpg"),
    view: 102,
    lan: ["Adobe", "Illustrator", "Social Media"],
    link: "https://www.behance.net/gallery/205305933/Creative-Business-Agency",
    btn: "Preview",
  },
  {
    id: 6,
    title: "Saffran Resaurant Design",
    img: require("./project-Img/RestaurantDesign.png"),
    view: 102,
    lan: ["Food", "Product", " Adobe", "Illustrator"],
    link: "https://www.behance.net/gallery/205306445/Saffran-Resaurant-Design",
    btn: "Preview",
  },
  {
    id: 7,
    title: "Bring Food E-Commerce (Client)",
    img: require("./project-Img/web_ss.png"),
    view: 102,
    lan: ["ReactJS", " Redux", "NodeJs", "ExpressJs"],
    link: "https://bring-foods.netlify.app/",
  },
  {
    id: 8,
    title: "Car Shop E-Commerce (Client)",
    img: require("./project-Img/carshop.png"),
    view: 102,
    lan: ["ReactJS", " Redux", "NodeJs", "ExpressJs"],
    link: "https://carshop-rk.netlify.app/",
  },
  {
    id: 9,
    title: "Portfolio Tonmoy (Client)",
    img: require("./project-Img/tonmoy_portofolio.png"),
    view: 102,
    lan: ["ReactJS", " Redux", "NodeJs", "ExpressJs"],
    link: "https://th-portfolio-client.vercel.app/",
  },
  {
    id: 10,
    title: "Bhuiyan Motor-Shops (Client)",
    img: require("./project-Img/bhuiya_motors.png"),
    view: 102,
    lan: ["ReactJS", " Redux", "Node", "Express", "Mongoose"],
    link: "https://bhuiyan-motors.netlify.app/",
  },
  {
    id: 11,
    title: "Sagor Departmental Store",
    img: require("./project-Img/sagor_store.png"),
    view: 102,
    lan: ["ReactJS", " Redux", "Node", "Express", "Mongoose"],
    link: "https://sagor-departmental.vercel.app/",
  },
];
